import { useState } from 'react'
import { useI18n } from '@ggs/i18n'
import { SelectInput } from '../../inputs'

import './SelectFilter.scss'

/**
 * @typedef {import('@mui/material').SelectChangeEvent} SelectChangeEvent
 */

/**
 * @typedef {Object} DistanceFieldProps
 * @property {{label: string, value: string}[]} options
 * @property {number} value
 * @property {function} setValue
 */

/**
 * Provides distance field form element.
 * @param {DistanceFieldProps} props
 * @return {JSX.Element}
 */
const DistanceSelectField = ({ options, value, setValue }) => {
  const { t } = useI18n()
  const [distanceFilter, setDistanceFilter] = useState(value ? value.toString() : '50')

  const selectOptions = [
    {
      label: t('Distance'),
      value: '',
      disabled: true,
    },
    ...options,
  ]

  /**
   * @param {SelectChangeEvent} e
   */
  const handleChange = (e) => {
    setDistanceFilter(e.target.value)
    setValue(parseInt(e.target.value))
  }

  return (
    <SelectInput
      fullWidth={false}
      label={t('Choose distance range')}
      id="search-filter-distance"
      allowEmpty={false}
      placeholder={t('Distance')}
      selectOptions={selectOptions}
      inputFields={{
        onChange: handleChange,
        value: `${distanceFilter}`,
      }}
      formControlClasses={{
        root: 'select-filter select-filter--distance',
      }}
      labelClasses={{
        root: 'select-filter__label',
      }}
      inputClasses={{
        root: 'select-filter__root',
        select: 'select-filter__select',
        icon: 'select-filter__icon',
      }}
      helperTextClasses={{
        root: 'select-filter__helper-text',
      }}
      listClasses={{
        root: 'select-filter-list',
      }}
      listItemClasses={{
        root: 'select-filter-list__item',
      }}
    />
  )
}

export default DistanceSelectField
